import React from 'react';
import moment from 'moment';
import { ReactComponent as Departure } from '../../../../../../../resources/images/svg/departure.svg';
import { ReactComponent as Time } from '../../../../../../../resources/images/svg/time.svg';
import { ReactComponent as Location } from '../../../../../../../resources/images/svg/location.svg';
import useTranslation from '../../../../../../hooks/translation/useTranslation';
import { useAuth } from '../../../../../../contexts/userContext/userContext';

function SearchRideTimes({ ride, vertical = false }) {
  const { trans, currentLanguage } = useTranslation();

  const { ticketBookingOptions } = useAuth();

  const duration = moment.duration(
    moment(ride.arrival.date).diff(ride.departure.date),
  );
  const hours = duration.hours().toFixed(0);
  const extraMinutes = duration.asMinutes() - hours * 60;

  const departureStation = ticketBookingOptions?.stations?.find(
    (station) => `${station?.value}` === `${ride.departure.stationCode}`,
  );

  const arrivalStation = ticketBookingOptions?.stations?.find(
    (station) => `${station?.value}` === `${ride.arrival.stationCode}`,
  );
  return (
    <div
      className={`flex gap-4 ${vertical ? 'flex-col' : ' flex-col xl:flex-row'}`}
    >
      <div className="flex gap-1 items-center">
        <Departure />
        <h3 className="m-0 text-base">{ride.departure.date.format('HH:mm')}</h3>
        <p className="m-0">
          {
              departureStation?.[`label_${currentLanguage}`]
              || departureStation?.label_ka
          }
        </p>
      </div>
      <div className="relative">
        {vertical && <div className="h-[64px] -translate-y-1/4 border-[1px] border-dashed border-gray-gr absolute left-2" />}
        <div className={`flex ${vertical && 'ml-5'} w-fit items-center rounded-lg px-8 py-1 bg-gradient-to-b from-gray-200 to-gray-200 bg-origin-padding bg-no-repeat gap-1`}>
          <Time className="pb-1 h-4" />
          <p className="m-0">
            {hours}
            {' '}
            {trans('hr')}
            {' '}
            {extraMinutes > 0 ? extraMinutes : 0}
            {' '}
            {trans('min')}
          </p>
        </div>
      </div>
      <div className="flex gap-1 items-center">
        <Location />
        <h3 className="m-0 text-base">{ride.arrival.date.format('HH:mm')}</h3>
        <p className="m-0">
          {
              arrivalStation?.[`label_${currentLanguage}`]
              || arrivalStation?.label_ka
          }
        </p>
      </div>
    </div>
  );
}

export default SearchRideTimes;
